import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormFieldCollectorContext } from "../Form";
import PropTypes from 'prop-types';
import { form_validator } from "../FormFieldValidator";
import SpinnerApple from "../../ui/spinner/Spinner.Apple";
import FeatherIcon from "../../ui/feather-icon/FeatherIcon";
import SvgIcon from "../../ui/svg-icons/SvgIcon";
import Spacer from "noood/comp/ui/spacer/Spacer";
import { ThemeContext } from "../../ui/theme/Theme";
import Icon from "noood/comp/ui/feather-icon/Icon";
import { Store } from "noood/util/local-storage/Store";
import * as stylex from "@stylexjs/stylex";
// only works with relative path, not with the alias noood
import { colors } from "noood/styles/colors.stylex";
import { string_util } from "noood/util/string/StringUtil";
import { FormContext } from "noood/contexts/contexts";
import { styling } from 'noood/styles/styles.stylex';
// @ts-ignore
_inject(".ev1t0sssr{box-shadow:0 0 0 2px rgba(255,141,141,.4)}", 3000);
_inject(".evpz759w{border-color:var(--red-50)}", 2000);
var styles = {
  errorFocus: {
    "TextField__styles.errorFocus": "TextField__styles.errorFocus",
    boxShadow: "ev1t0sssr",
    borderColor: "evpz759w",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  }
};
export default function TextField(props) {
  var _props$value, _props$validations, _form_$validationErro, _props$validations2, _props$validations2$i, _form_$validationErro2, _form_$formObj$props$, _form_$formObj, _props$styling, _props$styling2, _props$validations3, _props$placeholder, _props$validations4, _props$styling$inputR, _props$styling3, _stylex$props, _form_$formObj3, _props$validations5, _props$validations6, _errors$length, _validationErrors$len;
  var _useState = useState((_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : ''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(props.errors),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    show_context = _useState6[0],
    set_show_context = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    context_menu = _useState8[0],
    set_context_menu = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    doFocus = _useState0[0],
    setDoFocus = _useState0[1];
  var _useState1 = useState(),
    _useState10 = _slicedToArray(_useState1, 2),
    isFocused = _useState10[0],
    setIsFocused = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isPeeking = _useState12[0],
    setIsPeeking = _useState12[1];
  var peekTimerRef = useRef(null);
  var theme = useContext(ThemeContext);
  var form_ = useContext(FormContext);
  var thisRef = useRef(null);
  var nullIfEmptyString = function nullIfEmptyString(val) {
    var _val$trim;
    return (val === null || val === void 0 || (_val$trim = val.trim()) === null || _val$trim === void 0 ? void 0 : _val$trim.length) === 0 ? null : val;
  };
  function __change(event, field_value_collector) {
    var _props$__change;
    var field_errors = [];
    var v = event.target.value;
    field_errors = form_validator.validate(props.validations, v);
    setErrors(field_errors);
    field_value_collector === null || field_value_collector === void 0 || field_value_collector(nullIfEmptyString(event.target.value), props.name, field_errors);
    if (props.__validate) {
      props.__validate(event.target.value, function (rep) {
        var _rep$error;
        var new_errors_collection = [].concat(_toConsumableArray(errors), _toConsumableArray((_rep$error = rep.error) !== null && _rep$error !== void 0 ? _rep$error : []));
        setErrors(new_errors_collection);
        field_value_collector(nullIfEmptyString(event.target.value), props.name, new_errors_collection);
      });
    }
    (_props$__change = props.__change) === null || _props$__change === void 0 || _props$__change.call(props, event.target.value, field_errors);
    if (props.localStoreID) {
      Store.save(props.localStoreID, event.target.value);
    }
  }
  useEffect(function () {
    setValue(props.value);
  }, [props.value]);
  useEffect(function () {
    var _form_$__registerErro;
    // setErrors(props.errors)
    form_ === null || form_ === void 0 || (_form_$__registerErro = form_.__registerErrors) === null || _form_$__registerErro === void 0 || _form_$__registerErro.call(form_, props.name, props.errors);
  }, [props.errors]);
  useEffect(function () {
    var handleMouseUp = function handleMouseUp(e) {
      if (context_menu) {
        if (e.target.closest('.ui-context-container') === null && e.target.closest('.feather-chevron-up') === null) {
          set_context_menu(null);
        }
      }
    };
    document.addEventListener('mouseup', handleMouseUp);
    return function () {
      return document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [context_menu]);
  useEffect(function () {
    if (props.localStoreID) {
      Store.getAsync(props.localStoreID).then(function (val) {
        var _form_$__collect;
        form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, val, []);
      });
    }
  }, [props.localStoreID]);
  useEffect(function () {
    return function () {
      if (peekTimerRef.current) {
        clearTimeout(peekTimerRef.current);
      }
    };
  }, []);
  var togglePeek = function togglePeek() {
    if (isPeeking) {
      setIsPeeking(false);
      if (peekTimerRef.current) {
        clearTimeout(peekTimerRef.current);
        peekTimerRef.current = null;
      }
    } else {
      if (peekTimerRef.current) {
        clearTimeout(peekTimerRef.current);
      }
      setIsPeeking(true);
      peekTimerRef.current = setTimeout(function () {
        setIsPeeking(false);
        peekTimerRef.current = null;
      }, 10000);
    }
  };
  var REQ = ((_props$validations = props.validations) === null || _props$validations === void 0 ? void 0 : _props$validations.indexOf('required')) > -1;
  var REQ_BG = '#fff8db';
  var style = _objectSpread({}, props.more_style);
  useEffect(function () {
    if (props.autoFocus && thisRef.current) {
      thisRef.current.focus();
    }
  }, [props.autoFocus]);
  var hasValidationErrors = (form_ === null || form_ === void 0 || (_form_$validationErro = form_.validationErrors) === null || _form_$validationErro === void 0 || (_form_$validationErro = _form_$validationErro[props.name]) === null || _form_$validationErro === void 0 ? void 0 : _form_$validationErro.length) > 0;
  var isRequired = ((_props$validations2 = props.validations) === null || _props$validations2 === void 0 || (_props$validations2$i = _props$validations2.indexOf) === null || _props$validations2$i === void 0 ? void 0 : _props$validations2$i.call(_props$validations2, "required")) > -1;
  var validationErrors = form_ === null || form_ === void 0 || (_form_$validationErro2 = form_.validationErrors) === null || _form_$validationErro2 === void 0 ? void 0 : _form_$validationErro2[props.name];
  var finalValue = (_form_$formObj$props$ = form_ === null || form_ === void 0 || (_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj[props.name]) !== null && _form_$formObj$props$ !== void 0 ? _form_$formObj$props$ : "";
  if (props.parent_obj_property !== void 0) {
    var _form_$formObj$props$2, _form_$formObj2;
    finalValue = (_form_$formObj$props$2 = form_ === null || form_ === void 0 || (_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 || (_form_$formObj2 = _form_$formObj2[props.parent_obj_property]) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2[props.name]) !== null && _form_$formObj$props$2 !== void 0 ? _form_$formObj$props$2 : "";
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: (_props$styling = props.styling) === null || _props$styling === void 0 ? void 0 : _props$styling.box
  }, /*#__PURE__*/React.createElement("span", _extends({}, stylex.props(ui.label), {
    style: _objectSpread({}, (_props$styling2 = props.styling) === null || _props$styling2 === void 0 ? void 0 : _props$styling2.label)
  }), props.nolabel ? /*#__PURE__*/React.createElement(React.Fragment, null) : props.label ? /*#__PURE__*/React.createElement(React.Fragment, null, props.label, ((_props$validations3 = props.validations) === null || _props$validations3 === void 0 ? void 0 : _props$validations3.indexOf('required')) > -1 && /*#__PURE__*/React.createElement("span", {
    className: "text-error"
  }, " *")) : props["static"] || form_ !== null && form_ !== void 0 && form_.is_static ? (_props$placeholder = props.placeholder) !== null && _props$placeholder !== void 0 ? _props$placeholder : string_util.uc_words(props.name, "_") : /*#__PURE__*/React.createElement(React.Fragment, null, !props.placeholder && /*#__PURE__*/React.createElement(React.Fragment, null, string_util.uc_words(props.name, "_"), ((_props$validations4 = props.validations) === null || _props$validations4 === void 0 ? void 0 : _props$validations4.indexOf('required')) > -1 && " *"))), /*#__PURE__*/React.createElement("div", _extends({}, stylex.props(ui.inputBox, isFocused && ui.focus_ring, REQ && ui.required, REQ && ui.required_border, (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && styles.errorFocus, ((errors === null || errors === void 0 ? void 0 : errors.length) > 0 || (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) > 0) && ui.errorFocus, props["static"] && ui["static"], props.compact && ui.compact, props.stylexClassesArray && props.stylexClassesArray, props.disabled && ui.disabled), {
    style: (_props$styling$inputR = (_props$styling3 = props.styling) === null || _props$styling3 === void 0 ? void 0 : _props$styling3.inputRow) !== null && _props$styling$inputR !== void 0 ? _props$styling$inputR : {}
  }), props.icon && /*#__PURE__*/React.createElement(Icon, {
    icon: props.icon,
    className: [(_stylex$props = stylex.props(ui.icon, (props.disabled || props["static"] || (form_ === null || form_ === void 0 ? void 0 : form_.is_static)) && ui.disabledIcon, REQ && !props.disabled && ui.icon_on_required, props.iconStylex && props.iconStylex)) === null || _stylex$props === void 0 ? void 0 : _stylex$props.className].join(' ')
  }), props.svg_icon && /*#__PURE__*/React.createElement("div", {
    className: ['ui-textfield-icon-cell'].join(' ')
  }, /*#__PURE__*/React.createElement(SvgIcon, {
    icon: props.svg_icon
  })), props.__context && /*#__PURE__*/React.createElement("div", {
    className: 'ui-textfield-context-cell',
    onClick: function onClick() {
      set_context_menu(!context_menu ? props.__context(true) : null);
    }
  }, /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: context_menu ? 'chevron-up' : 'chevron-down'
  }), context_menu), props["static"] || form_ !== null && form_ !== void 0 && form_.is_static ? /*#__PURE__*/React.createElement(React.Fragment, null, form_ === null || form_ === void 0 || (_form_$formObj3 = form_.formObj) === null || _form_$formObj3 === void 0 ? void 0 : _form_$formObj3[props.name]) : /*#__PURE__*/React.createElement(FormFieldCollectorContext.Consumer, null, function (field_value_collector) {
    var _props$styling4;
    return /*#__PURE__*/React.createElement("input", _extends({
      value: finalValue,
      autoComplete: 'off',
      disabled: props.disabled,
      onKeyUp: function onKeyUp(e) {
        if (e.keyCode === 13) {
          var _props$__enter;
          (_props$__enter = props.__enter) === null || _props$__enter === void 0 || _props$__enter.call(props, e.target.value);
        }
      },
      onFocus: function onFocus(e) {
        setIsFocused(true);
      },
      ref: thisRef,
      onBlur: function onBlur(e) {
        var _props$__blur;
        setIsFocused(false);
        (_props$__blur = props.__blur) === null || _props$__blur === void 0 || _props$__blur.call(props, e.target.value);
      },
      onChange: function onChange(e) {
        setValue(e.target.value);
        __change(e, field_value_collector);
      }
    }, stylex.props(ui.inputField, props.disabled && ui.input_disabled, REQ && !props.disabled && ui.required, props.inputStylex && props.inputStylex), {
      type: props.password ? isPeeking ? 'text' : 'password' : 'text',
      style: _objectSpread(_objectSpread(_objectSpread({}, style), (_props$styling4 = props.styling) === null || _props$styling4 === void 0 ? void 0 : _props$styling4.input), {
        border: "0px dotted red"
      }),
      placeholder: props.placeholder,
      name: props.name
    }));
  }), props.password && !(props["static"] || form_ !== null && form_ !== void 0 && form_.is_static) && !props.disabled && /*#__PURE__*/React.createElement("div", {
    className: 'ui-textfield-peek-cell',
    onClick: togglePeek,
    title: isPeeking ? 'Hide password' : 'Show password',
    style: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      padding: '0 2px'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: isPeeking ? 'eye-off' : 'eye',
    size: 17,
    color: isRequired ? 'var(--text-on-required-secondary)' : 'var(--shade-60)'
  })), !(props["static"] || form_ !== null && form_ !== void 0 && form_.is_static || props.no_status) && /*#__PURE__*/React.createElement("div", {
    className: "ui-textfield-status",
    onClick: function onClick(e) {
      if (thisRef.current) {
        thisRef.current.focus();
      }
    }
  }, ((_props$validations5 = props.validations) === null || _props$validations5 === void 0 ? void 0 : _props$validations5.length) > 0 && (errors === null || errors === void 0 ? void 0 : errors.length) > 0 || hasValidationErrors && /*#__PURE__*/React.createElement(Icon, {
    icon: 'x',
    size: 17,
    color: 'var(--shade-error)',
    animated: true
  }), props.loading ? /*#__PURE__*/React.createElement("div", stylex.props(styling.center_center), /*#__PURE__*/React.createElement(SpinnerApple, null)) : ((_props$validations6 = props.validations) === null || _props$validations6 === void 0 ? void 0 : _props$validations6.length) > 0 && (errors === null || errors === void 0 ? void 0 : errors.length) === 0 && !hasValidationErrors && /*#__PURE__*/React.createElement(Icon, {
    icon: 'check',
    size: 17,
    color: isRequired ? 'var(--shade-success-on-required)' : 'var(--shade-success)',
    animated: true
  }))), props.caption && !(props["static"] || form_ !== null && form_ !== void 0 && form_.is_static) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 3
  }), /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: "block"
    }
  }, {
    className: "TextField__ui.caption ev1blgh98 ev4z9k3i"
  }), props.caption)), ((errors === null || errors === void 0 ? void 0 : errors.length) > 0 || (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) > 0) && (props.showValidations === void 0 || props.showValidations) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 5
  }), /*#__PURE__*/React.createElement("ol", stylex.props(ui.errorMsg, (props.show_error_bullets || ((_errors$length = errors === null || errors === void 0 ? void 0 : errors.length) !== null && _errors$length !== void 0 ? _errors$length : 0) + ((_validationErrors$len = validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) !== null && _validationErrors$len !== void 0 ? _validationErrors$len : 0) > 1) && ui.bulleted), [].concat(_toConsumableArray(errors !== null && errors !== void 0 ? errors : []), _toConsumableArray(validationErrors !== null && validationErrors !== void 0 ? validationErrors : [])).map(function (e, idx) {
    return /*#__PURE__*/React.createElement("li", _extends({}, {
      className: "TextField__ui.error_item ev17q8loj"
    }, {
      key: idx
    }), e);
  })), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  }))), props.spacer && /*#__PURE__*/React.createElement(Spacer, {
    mtop: props.spacer
  }));
}
TextField.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  label: PropTypes.string,
  validations: PropTypes.array,
  showValidations: PropTypes.number,
  caption: PropTypes.string,
  __change: PropTypes.func,
  __enter: PropTypes.func,
  __context: PropTypes.func,
  // this is for when you want to check the value of the textfield against some database
  __validate: PropTypes.func,
  loading: PropTypes.bool,
  compact: PropTypes.bool,
  "static": PropTypes.bool // show this field as a label-value, not as label-textfield
  ,

  more_style: PropTypes.object,
  spacer: PropTypes.number,
  no_status: PropTypes.bool
  /** add this prop if you want to turn this field into a password field */,
  password: PropTypes.bool,
  container_style: PropTypes.object,
  styling: PropTypes.shape({
    box: PropTypes.object,
    label: PropTypes.object,
    inputRow: PropTypes.object,
    inputCell: PropTypes.object,
    input: PropTypes.object
  }),
  errors: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  __blur: PropTypes.func,
  localStoreID: PropTypes.string,
  autoFocus: PropTypes.bool,
  nolabel: PropTypes.bool,
  stylexClassesArray: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.string
};
TextField.defaultProps = {
  showValidations: 1,
  nolabel: false
};
TextField.displayName = '__textfield_';

// @ts-ignore
_inject(".ev78zum5{display:flex}", 3000);
_inject(".ev6s0dn4{align-items:center}", 3000);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);
_inject(".ev1bkuceq{border:1px solid var(--shade-20)}", 1000);
_inject(".ev1y7ric0{background-color:var(--shade-05)}", 3000);
_inject(".ev1tgzv6z{height:var(--field-height)}", 4000);
_inject(".ev14odnwx{padding:5px}", 1000);
_inject(".ev1jnr06f{gap:4px}", 2000);
_inject(".evt0e3qv{cursor:default}", 3000);
_inject(".ev1s07b3s:disabled{cursor:not-allowed}", 3092);
_inject(".ev1kahdyr{border-color:light-dark(red,blue)}", 2000);
_inject(".eve8uvvx{list-style:none}", 2000);
_inject(".ev1717udv{padding:0}", 1000);
_inject(".ev1ghz6dp{margin:0}", 1000);
_inject(".ev9l8mzu{color:var(--shade-negative)}", 3000);
_inject(".evif65rj{font-size:14px}", 3000);
_inject(".evglst9c{list-style:square}", 2000);
_inject(".evt102qc{margin-left:15px}", 4000);
_inject(".evr0sq7q{color:var(--shade-80)}", 3000);
_inject(".evvxz5d1::placeholder{color:var(--shade-50)}", 8000);
_inject(".evqkw79p{font-size:var(--text-size)}", 3000);
_inject(".ev1wty727{border:0}", 1000);
_inject(".ev1md70p1{background:transparent}", 1000);
_inject(".ev1a2a7pz{outline:none}", 2000);
_inject(".ev98rzlu{flex:1}", 2000);
_inject(".ev1myo2o9{height:calc(var(--field-height) - 2px)}", 4000);
_inject(".evh8yej3{width:100%}", 4000);
_inject(".ev160dt0k{font-family:font1}", 3000);
_inject(".evlrawln{height:25px}", 4000);
_inject(".evgh8whm{color:var(--shade-60)}", 3000);
_inject(".ev7u93xe{color:var(--text-on-required-secondary)}", 3000);
_inject(".ev1lko15j{background-color:var(--shade-required)}", 3000);
_inject(".ev1sqloac{border-color:var(--shade-40)}", 2000);
_inject(".ev1y4fvtb{border-width:var(--evntlfdk)}", 2000);
_inject(".ev3vhh18{border-style:var(--ev1a02swc)}", 2000);
_inject(".ev1yv24of::placeholder{color:#2b2b2b4D}", 8000);
_inject(".ev12s56vh{color:#2b2b2b}", 3000);
_inject(".ev1h6gzvc{cursor:not-allowed}", 3000);
_inject(".ev1nhvcw1{justify-content:flex-start}", 3000);
_inject(".ev1jo8pe8{color:var(--shade-30)}", 3000);
_inject(".evc5895u{border-color:var(--shade-30)}", 2000);
_inject(".evgih7pf{border-color:var(--shade-05)}", 2000);
_inject(".ev1lcnupm{color:var(--shade-10)}", 3000);
_inject(".ev17q8loj{color:var(--text-error)}", 3000);
_inject(".ev1blgh98{color:var(--shade-40)}", 3000);
_inject(".ev4z9k3i{font-size:13px}", 3000);
_inject(".evev6ut4{border:1px solid var(--shade-required-border)}", 1000);
_inject(".ev1mg8e2z{box-shadow:0 0 0 3px light-dark(rgba(104,152,255,.25),rgba(215,255,114,.06))}", 3000);
_inject(".evnz68lp{transition:box-shadow .2s}", 2000);
_inject(".ev180x1ni{color:var(--shade-10)!important}", 3000);
var ui = {
  inputBox: {
    "TextField__ui.inputBox": "TextField__ui.inputBox",
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    borderRadius: "evxwrc4x",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    border: "ev1bkuceq",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    backgroundColor: "ev1y7ric0",
    height: "ev1tgzv6z",
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    gap: "ev1jnr06f",
    rowGap: null,
    columnGap: null,
    cursor: "evt0e3qv ev1s07b3s",
    $$css: true
  },
  errorFocus: {
    "TextField__ui.errorFocus": "TextField__ui.errorFocus",
    borderColor: "ev1kahdyr",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  errorMsg: {
    "TextField__ui.errorMsg": "TextField__ui.errorMsg",
    listStyle: "eve8uvvx",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    padding: "ev1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    margin: "ev1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "ev9l8mzu",
    fontSize: "evif65rj",
    $$css: true
  },
  bulleted: {
    "TextField__ui.bulleted": "TextField__ui.bulleted",
    listStyle: "evglst9c",
    listStyleImage: null,
    listStylePosition: null,
    listStyleType: null,
    marginLeft: "evt102qc",
    marginInlineStart: null,
    marginInlineEnd: null,
    $$css: true
  },
  inputField: {
    "TextField__ui.inputField": "TextField__ui.inputField",
    color: "evr0sq7q",
    "::placeholder_color": "evvxz5d1",
    fontSize: "evqkw79p",
    border: "ev1wty727",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    background: "ev1md70p1",
    backgroundAttachment: null,
    backgroundClip: null,
    backgroundColor: null,
    backgroundImage: null,
    backgroundOrigin: null,
    backgroundPosition: null,
    backgroundPositionX: null,
    backgroundPositionY: null,
    backgroundRepeat: null,
    backgroundSize: null,
    outline: "ev1a2a7pz",
    outlineColor: null,
    outlineOffset: null,
    outlineStyle: null,
    outlineWidth: null,
    flex: "ev98rzlu",
    flexGrow: null,
    flexShrink: null,
    flexBasis: null,
    alignItems: "ev6s0dn4",
    display: "ev78zum5",
    height: "ev1myo2o9",
    width: "evh8yej3",
    fontFamily: "ev160dt0k",
    $$css: true
  },
  compact: {
    "TextField__ui.compact": "TextField__ui.compact",
    height: "evlrawln",
    $$css: true
  },
  icon: {
    "TextField__ui.icon": "TextField__ui.icon",
    color: "evgh8whm",
    $$css: true
  },
  icon_on_required: {
    "TextField__ui.icon_on_required": "TextField__ui.icon_on_required",
    color: "ev7u93xe",
    $$css: true
  },
  required: {
    "TextField__ui.required": "TextField__ui.required",
    backgroundColor: "ev1lko15j",
    borderColor: "ev1sqloac",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderWidth: "ev1y4fvtb",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "ev3vhh18",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    "::placeholder_color": "ev1yv24of",
    color: "ev12s56vh",
    $$css: true
  },
  static: {
    "TextField__ui.static": "TextField__ui.static",
    backgroundColor: "ev1y7ric0",
    cursor: "ev1h6gzvc",
    border: "ev1wty727",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    display: "ev78zum5",
    alignItems: "ev6s0dn4",
    justifyContent: "ev1nhvcw1",
    padding: "ev14odnwx",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    color: "ev1jo8pe8",
    height: "ev1tgzv6z",
    $$css: true
  },
  disabled: {
    "TextField__ui.disabled": "TextField__ui.disabled",
    backgroundColor: "ev1y7ric0",
    borderColor: "evgih7pf",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    cursor: "ev1h6gzvc",
    color: "ev1lcnupm",
    $$css: true
  },
  disabledIcon: {
    "TextField__ui.disabledIcon": "TextField__ui.disabledIcon",
    color: "ev1lcnupm",
    $$css: true
  },
  required_border: {
    "TextField__ui.required_border": "TextField__ui.required_border",
    border: "evev6ut4",
    borderWidth: null,
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: null,
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: null,
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  focus_ring: {
    "TextField__ui.focus_ring": "TextField__ui.focus_ring",
    boxShadow: "ev1mg8e2z",
    transition: "evnz68lp",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  input_disabled: {
    "TextField__ui.input_disabled": "TextField__ui.input_disabled",
    color: "ev180x1ni",
    $$css: true
  }
};